import React from 'react';
import { ArrowLeftIcon, FileTextIcon } from 'lucide-react';
export function TermsAndConditions() {
  return <main className="min-h-screen w-full bg-[#fcfbf7] px-5 py-10 text-[#344833] sm:px-8 sm:py-16" data-id="element-509" data-mp="2jgdw72aysoce">
      <div className="mx-auto max-w-3xl" data-id="element-510" data-mp="2eovs45dna7n7">
        <a href="/" className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.12em] text-[#597050] transition-colors hover:text-[#30452e]" data-id="element-511" data-mp="2enuepu95p92b">
          <ArrowLeftIcon size={16} data-id="element-512" data-mp="25qtt1vdh1p2k" />
          VOLVER A CÓDIGO FITNESS™
        </a>

        <article className="mt-12 border border-[#e1e4da] bg-[#fffefa] p-7 shadow-[0_12px_35px_rgba(61,75,53,0.07)] sm:p-12" data-id="element-513" data-mp="20pecafibu4pz">
          <div className="flex items-center gap-3 text-[#66805c]" data-id="element-514" data-mp="1vt5pcfxw1789">
            <FileTextIcon size={20} strokeWidth={1.5} aria-hidden="true" data-id="element-515" data-mp="1rqsvopwf0zru" />
            <p className="text-xs font-bold tracking-[0.2em]" data-id="element-516" data-mp="3q5m2m0p3plmm">
              INFORMACIÓN LEGAL
            </p>
          </div>
          <h1 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-517" data-mp="3m4ts744htaor">
            Términos y Condiciones
          </h1>

          <div className="mt-10 space-y-9 leading-8 text-[#5d6a59]" data-id="element-518" data-mp="2u3nvvnj8sqni">
            <section data-id="element-519" data-mp="2u4yyvl4v5udk">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-520" data-mp="2u1b6wqf2hg0y">
                Condiciones de compra
              </h2>
              <p className="mt-3" data-id="element-521" data-mp="2k4ybno3viu43">
                Al realizar una compra de Código Fitness™ confirmas que has
                revisado la descripción del producto y aceptas estos Términos y
                Condiciones, la Política de Privacidad y la Política de
                Reembolsos. La compra da acceso a contenido digital, conforme a
                la oferta presentada al momento del pago.
              </p>
            </section>

            <section data-id="element-522" data-mp="332svkx6jiq19">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-523" data-mp="3329e1hksy3nr">
                Acceso inmediato al producto digital
              </h2>
              <p className="mt-3" data-id="element-524" data-mp="3vl6fdsv1kbhc">
                Una vez confirmado el pago, el contenido digital se entrega o se
                habilita de forma inmediata mediante las instrucciones o el
                acceso indicado en la compra. Es responsabilidad del usuario
                proporcionar datos correctos y conservar la información de
                acceso recibida.
              </p>
            </section>

            <section data-id="element-525" data-mp="3rfsy8jcnj8dh">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-526" data-mp="3rgm5rmjfq1wo">
                Licencia de uso
              </h2>
              <p className="mt-3" data-id="element-527" data-mp="3mjm03cqhz163">
                Al adquirir Código Fitness™ recibes una licencia limitada,
                personal, no exclusiva, no transferible y revocable para
                consultar y utilizar el contenido con fines personales. La
                compra no implica la transferencia de derechos de propiedad
                intelectual sobre las guías, recetas, textos, diseños o
                materiales incluidos.
              </p>
            </section>

            <section data-id="element-528" data-mp="2ysynie5mznd7">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-529" data-mp="2oo9xi0nf5f1w">
                Propiedad intelectual y restricciones
              </h2>
              <p className="mt-3" data-id="element-530" data-mp="2tmbgklkuhedd">
                Todos los contenidos de Código Fitness™ están protegidos por
                las normas aplicables de propiedad intelectual. No está
                permitido copiar, reproducir, modificar, distribuir, publicar,
                vender, revender, compartir, sublicenciar o explotar los
                materiales, total o parcialmente, sin autorización previa y
                expresa.
              </p>
              <p className="mt-3" data-id="element-531" data-mp="2auipiwpc638a">
                Tampoco está permitido compartir enlaces de descarga, archivos,
                accesos o credenciales con terceros. El uso no autorizado puede
                resultar en la suspensión del acceso, sin perjuicio de las
                acciones que correspondan.
              </p>
            </section>

            <section data-id="element-532" data-mp="1s52jxuysnkl0">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-533" data-mp="1s4j3yjspf69m">
                Responsabilidad del usuario
              </h2>
              <p className="mt-3" data-id="element-534" data-mp="3owg9yprkf3z4">
                El usuario es responsable de utilizar el contenido de manera
                personal, razonable y conforme a estos términos. También es
                responsable de evaluar si las recomendaciones educativas se
                ajustan a su situación particular y de consultar a un
                profesional de la salud cuando sea necesario.
              </p>
            </section>

            <section data-id="element-535" data-mp="ce01ma0kc7kv">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-536" data-mp="cei8e0kuq471">
                Limitación de responsabilidad
              </h2>
              <p className="mt-3" data-id="element-537" data-mp="lfq2e6gc4ivb">
                Código Fitness™ se ofrece con fines educativos e informativos.
                No garantiza resultados específicos, ya que estos dependen de
                múltiples factores personales. En la máxima medida permitida por
                la ley aplicable, Código Fitness™ no será responsable por
                decisiones, usos o resultados derivados de la aplicación del
                contenido.
              </p>
            </section>

            <section data-id="element-538" data-mp="17pzi9z6121dv">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-539" data-mp="szilwu8921nu">
                Condiciones generales del servicio
              </h2>
              <p className="mt-3" data-id="element-540" data-mp="xx0rqbqz00rm">
                Podemos actualizar estos términos cuando sea necesario para
                reflejar cambios en el servicio, la operación o la normativa
                aplicable. El uso continuado del contenido después de la
                publicación de una actualización supone la aceptación de los
                términos vigentes. Si surge una consulta sobre tu compra,
                utiliza el canal de soporte indicado en la confirmación de pago.
              </p>
            </section>
          </div>
        </article>

        <p className="mt-8 text-center text-xs text-[#7a8574]" data-id="element-541" data-mp="29e0k17dbifln">
          © 2026 Código Fitness™. Todos los derechos reservados.
        </p>
      </div>
    </main>;
}